
import { Component, Vue } from 'vue-property-decorator'
import moment, { Moment } from 'moment'
import WangEditor from 'wangeditor'
import appconst from "@/lib/appconst";
import { OperationPointsService, RuleUserReamarkDto } from "@/api/service-proxies";
@Component
export default class details extends Vue {
    OperationPoints = new OperationPointsService()
    RuleUserReamarkDto = new RuleUserReamarkDto();
    imageUploadAction = appconst.remoteServiceBaseUrl + 'sysadmin/UploadFile/ProductUpload'
    mounted() {
        const value = Number(this.$route.query.id);
        this.OperationPoints.getRuleUserReamark(value)
            .then(result => {
               this.RuleUserReamarkDto =result;
                this.initEditor();
            })
            .finally(() => {
            });

    }
    goback() {
        this.$router.back()
    }
    confirm() {
        this.OperationPoints.updateRuleUserReamark(this.RuleUserReamarkDto)
            .then(result => {
              this.$message.success("修改成功");
            })
            .finally(() => {
              this.$router.back();
            });

    }
    private initEditor() {
        let editor = new WangEditor('#editor')
        editor.config.menus = [
            'head',
            'bold',
            'fontSize',
            'italic',
            'underline',
            'strikeThrough',
            'indent',
            'lineHeight',
            'foreColor',
            'backColor',
            'list',
            'justify',
            'quote',
            'emoticon',
            'image',
            //'video',
            'splitLine',
            'undo',
            'redo',
        ]
        editor.config.zIndex = 20
        editor.config.uploadImgServer = this.imageUploadAction
        editor.config.uploadFileName = 'file'
        editor.config.uploadImgHooks = {
            customInsert: (insertImgFn: any, response: any) => {
                editor.cmd.do(
                    'insertHTML',
                    `<img src="${response.result.url}" style="max-width:100%;" contenteditable="false"/>`
                )
            },
        }
        editor.config.uploadVideoServer = this.imageUploadAction
        editor.config.uploadVideoName = 'file'
        editor.config.uploadVideoMaxSize = 1 * 1024 * 1024 * 100 // 100M
        editor.config.uploadVideoAccept = ['mp4']
        editor.config.uploadVideoHooks = {
            before: (xhr) => {
                // if (this.inputValue2) {
                //     let div = document.createElement('div')
                //     div.innerHTML = this.inputValue2
                //     if (div.querySelectorAll('video').length >= 3) {
                //         return {
                //             prevent: true,
                //             msg: '最多只能上传3个视频',
                //         }
                //     }
                // }
            },
            customInsert: (insertVideoFn: any, response: any) => {
                editor.cmd.do(
                    'insertHTML',
                    `<p><video poster="${response.result.url}" controls="controls" style="max-width:100%"><source src="${response.result.url}" type="video/mp4" /></video></p><p>&#8203</p>`
                )
            },
        }
        editor.config.onchange = (html) => {
          this.RuleUserReamarkDto.ruleUseRemarks = html
        }
        editor.create()
        // $(".w-e-text-container").css("height", "700px")
         editor.txt.html(this.RuleUserReamarkDto.ruleUseRemarks)
    }
}
